// ** Initial State
const initialState = {
  mapType: 'NORMAL',
  objectId: null,
  isClickObject: false,
  area0001: true, // 비행금지 구역
  area0002: true, // 비행제한 구역
  area0003: true, // 관제권(공항)
  area0004: true, // 비행장(군사)
  area0005: true, // 이착륙장(RC비행장)
  area0006: true, // 초경량비행장치
  sensor: 'dust',

  drawType: null,

  ctrlDrawType: null,

  drawCheck: ''
};

const controlReducerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'MAP_TYPE_CHANGE':
      return { ...state, mapType: action.value };

    case 'OBJECT_CLICK':
      return { ...state, objectId: action.value, isClickObject: true };

    case 'OBEJCT_UN_CLICK':
      return { ...state, isClickObject: false };

    case 'AREA_CLICK':
      if (action.value === '0001') {
        return {
          ...state,
          area0001: !state.area0001
        };
      } else if (action.value === '0002') {
        return {
          ...state,
          area0002: !state.area0002
        };
      } else if (action.value === '0003') {
        return {
          ...state,
          area0003: !state.area0003
        };
      } else if (action.value === '0004') {
        return {
          ...state,
          area0004: !state.area0004
        };
      } else if (action.value === '0005') {
        return {
          ...state,
          area0005: !state.area0005
        };
      } else if (action.value === '0006') {
        return {
          ...state,
          area0006: !state.area0006
        };
      } else {
        return {
          state
        };
      }
    case 'SENSOR_CLICK':
      return {
        ...state,
        sensor: action.value
      };
      break;
    default:
      return state;

    case 'DRAW_TYPE_CHANGE':
      return {
        ...state,
        drawType: action.value
      };

    case 'CTRL_DRAW_TYPE_CHANGE':
      return {
        ...state,
        ctrlDrawType: action.value
      };

    case 'DRAW_CHECK':
      return {
        ...state,
        drawCheck: action.value
      };
  }
};

export default controlReducerReducer;
